// extracted by mini-css-extract-plugin
export var button = "_jp-2";
export var card = "_jp-0";
export var closeButtonContainer = "_jp-3";
export var iconContainer = "_jp-1";